import { distanceBetweenPoints } from "./util";
export function calcColumnLine(rules) {
    const floorPoints = [];
    const postWidth = rules.postWidth || 0;
    const postHalf = postWidth / 2 || 0;
    // рабочая длина между центрами крайних столбов
    const workLength = rules.l - postWidth;
    const countPillar = Math.floor(workLength / rules.maxSpan);
    const spans = workLength / (countPillar + 1);
    const total = countPillar + 2;
    for (let i = 0; i < total; i++) {
        const x = postHalf + spans * i;
        floorPoints.push([x, 0]);
    }
    return floorPoints;
}
export function calcColumnLineFromSegment(segment, maxSpan) {
    const { from, to, length } = segment;
    const points = [];
    if (length <= 0)
        return points;
    // направление сегмента
    const dx = to[0] - from[0];
    const dy = to[1] - from[1];
    const dirX = dx / length;
    const dirY = dy / length;
    // сколько внутренних промежутков
    const countPillar = Math.floor(length / maxSpan);
    // шаг между столбами
    const span = length / (countPillar + 1);
    const total = countPillar + 2; // включая края
    for (let i = 1; i < total - 1; i++) {
        const dist = span * i;
        const x = from[0] + dirX * dist;
        const y = from[1] + dirY * dist;
        points.push([x, y]);
    }
    return points;
}
export function updateLimitedPointsOnLine(line, w) {
    const newLine = line.map((p, i) => {
        if (i === 0)
            return [p[0] + w / 2, p[1]];
        if (i === line.length - 1)
            return [p[0] - w / 2, p[1]];
        return p;
    });
    return newLine;
}
export function revertLimitedPointsOnLine(line, w) {
    const originalLine = line.map((p, i) => {
        // if (i === 0) return [p[0] - w / 2, p[1]]
        // if (i === line.length - 1) return [p[0] + w / 2, p[1]]
        return p;
    });
    return originalLine;
}
export function centeredColumnLineL(points, l) {
    const newPoints = [];
    for (let i = 0; i < points.length; i++) {
        newPoints.push([points[i][0] - l / 2, points[i][1]]);
    }
    return newPoints;
}
export function centeredColumnLineW(points, w) {
    const newPoints = [];
    for (let i = 0; i < points.length; i++) {
        newPoints.push([points[i][0], points[i][1] - w / 2]);
    }
    return newPoints;
}
export function placeOnPlane(ColumnLine, w, shift = 0) {
    const position = [];
    for (const column of ColumnLine) {
        position.push([column[0], 0, column[1] - w / 2 + shift]);
        position.push([column[0], 0, column[1] + w / 2 - shift]);
    }
    return position;
}
export function createSegmentsFromLine(line) {
    const segments = [];
    let from = line[0];
    for (let i = 1; i < line.length; i++) {
        segments.push({
            length: distanceBetweenPoints(from, line[i]),
            from: from,
            to: line[i],
        });
        from = line[i];
    }
    return segments;
}
